import { useQuery } from 'data-fetching-client';
import { PHONE_NUMBER } from 'pricing-pages-api/EarlyRequesterNames';
import { GET_PHONE_NUMBER } from 'pricing-pages-api/phone-number/queries';
import { EN } from 'pricing-pages-lib/constants/Languages';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { dataFetchingClient } from '../utils/dataFetchingClient';
export const DEFAULT_PHONE_NUMBER = '1 888 482 7768';
export const usePhoneNumber = ({
  isPublic
} = {}) => {
  const preferredLanguage = getPreferredLanguage() || EN;

  // Check if we have cached data
  const variables = {
    earlyRequestName: PHONE_NUMBER,
    preferredLanguage
  };
  const cachedData = dataFetchingClient.readQuery({
    query: GET_PHONE_NUMBER,
    variables
  });

  // For public users:
  // - Use cached data if available
  // - Skip the query if public (to prevent unauthorized API calls)
  const shouldSkip = isPublic;
  const {
    data,
    error,
    loading
  } = useQuery(GET_PHONE_NUMBER, {
    variables,
    skip: shouldSkip
  });

  // If we're public and have cached data, use it
  const phoneNumberData = isPublic && cachedData ? cachedData.phoneNumber : data === null || data === void 0 ? void 0 : data.phoneNumber;
  const phoneNumber = phoneNumberData === null || phoneNumberData === void 0 ? void 0 : phoneNumberData.phoneNumber;
  const phoneNumberToUse = !loading && !phoneNumber ? DEFAULT_PHONE_NUMBER : phoneNumber;
  return {
    phoneNumber: phoneNumberToUse || DEFAULT_PHONE_NUMBER,
    error,
    loading
  };
};